import autosize from 'autosize'

up.compiler('[autosize]', (element) => {
  autosize(element)
})
